import { useState } from 'react'
import { TileLayer } from 'react-leaflet'

// Hintergrundkarten und Umschalter – Kopie aus der Taktischen Karte (apps/fuehrung/src/pages/TaktischeKartePage.tsx)
export type Grundkarte = 'karte' | 'satellit' | 'topo'

export const GRUNDKARTEN: Array<{ key: Grundkarte; label: string; url: string; attribution: string; maxNativeZoom: number }> = [
  {
    key: 'karte', label: 'Karte',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxNativeZoom: 19,
  },
  {
    key: 'satellit', label: 'Satellit',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Luftbild: &copy; Esri, Maxar, Earthstar Geographics',
    maxNativeZoom: 19,
  },
  {
    key: 'topo', label: 'Höhenlinien',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: 'Kartendaten: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (CC-BY-SA)',
    maxNativeZoom: 17,
  },
]

/** Gewählte Ansicht pro Browser merken */
export function useGrundkarte(speicherKey: string): [Grundkarte, (g: Grundkarte) => void] {
  const [wahl, setWahl] = useState<Grundkarte>(() => {
    try {
      const v = localStorage.getItem(speicherKey)
      if (GRUNDKARTEN.some(g => g.key === v)) return v as Grundkarte
    } catch { /* localStorage nicht verfügbar */ }
    return 'karte'
  })
  const setzen = (g: Grundkarte) => {
    setWahl(g)
    try { localStorage.setItem(speicherKey, g) } catch { /* ignorieren */ }
  }
  return [wahl, setzen]
}

export function GrundkarteLayer({ grundkarte }: { grundkarte: Grundkarte }) {
  const gk = GRUNDKARTEN.find(g => g.key === grundkarte) ?? GRUNDKARTEN[0]
  // key erzwingt einen neuen TileLayer – react-leaflet tauscht die url sonst ohne Attribution
  return <TileLayer key={gk.key} url={gk.url} attribution={gk.attribution} maxNativeZoom={gk.maxNativeZoom} maxZoom={20} />
}

export function GrundkarteUmschalter({ grundkarte, onChange, className = 'absolute bottom-3 left-3 z-20' }:
  { grundkarte: Grundkarte; onChange: (g: Grundkarte) => void; className?: string }) {
  return (
    <div className={`${className} flex overflow-hidden rounded-xl border border-dark-border bg-dark-bg-secondary/95 shadow-2xl backdrop-blur`}>
      {GRUNDKARTEN.map(g => (
        <button key={g.key} type="button" aria-pressed={grundkarte === g.key}
          onClick={() => onChange(g.key)}
          className={`min-h-[48px] px-3 text-xs font-semibold transition-colors ${grundkarte === g.key
            ? 'bg-primary-500 text-white'
            : 'text-dark-text-muted hover:bg-dark-bg-tertiary hover:text-dark-text'}`}>
          {g.label}
        </button>
      ))}
    </div>
  )
}
